import "./deno-mock.js";
import { Plugin } from "./esbuild-wasm.ts";
import { denoResolverPlugin } from "jsr:@luca/esbuild-deno-loader@0.10";

// ported from https://deno.land/x/esbuild_deno_loader@0.9.0/src/plugin_deno_resolver.ts
export interface DenoResolverPluginOptions {
  /**
   * Specify the path to a deno.json config file to use. This is equivalent to
   * the `--config` flag to the Deno executable. This path must be absolute.
   */
  configPath?: string;
  /**
   * Specify a URL to an import map file to use when resolving import
   * specifiers. This is equivalent to the `--import-map` flag to the Deno
   * executable. This URL may be remote or a local file URL.
   *
   * If this option is not specified, the deno.json config file is consulted to
   * determine what import map to use, if any.
   */
  importMapURL?: string;
}

/**  {@link denoResolverPlugin} for browser */
export const resolver: (options?: DenoResolverPluginOptions) => Plugin =
  denoResolverPlugin as unknown as (
    options?: DenoResolverPluginOptions,
  ) => Plugin;

// denoCacheMetadata={"headers":{"vary":"Authorization,Accept-Encoding,Origin","x-content-type-options":"nosniff","source-age":"90","expires":"Fri, 08 Nov 2024 10:15:00 GMT","x-timer":"S1731060601.748545,VS0,VE1","content-type":"text/plain; charset=utf-8","x-github-request-id":"2EAE:3E7F7D:1BC92D:1E84F5:672DDE07","cache-control":"max-age=300","x-xss-protection":"1; mode=block","x-served-by":"cache-iad-kcgs7200100-IAD","via":"1.1 varnish","x-frame-options":"deny","etag":"W/\"0b0fff244edba337fc3aeef0bb141e68954fcfb7c7e721df5c99d7db7f40af3b\"","accept-ranges":"bytes","x-cache":"HIT","strict-transport-security":"max-age=31536000","access-control-allow-origin":"*","cross-origin-resource-policy":"cross-origin","x-cache-hits":"0","date":"Fri, 08 Nov 2024 10:10:00 GMT","content-security-policy":"default-src 'none'; style-src 'unsafe-inline'; sandbox","x-fastly-request-id":"6b99daa7ef45ef8bd92dc3f685ba1d205fbb4579"},"url":"https://raw.githubusercontent.com/takker99/ScrapJupyter/v1.7.4/deps/esbuild_deno_loader.ts","time":1731060600}